// New custom hook file, e.g., useMoveToMailboxHook.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { moveToMailbox } from "../helpers/AxiosInstance"; 

interface IUseMoveToMailboxHook {
  queryKey: string[];
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}

const useMoveToMailboxHook = (props: IUseMoveToMailboxHook) => {
  const { queryKey, showSuccessToast = true, showErrorToast = true } = props;
  const queryClient = useQueryClient();

  const {
    isPending: isMoveToMailboxLoading,
    mutateAsync,
    isSuccess: isMoveToMailboxSuccess,
    data: moveToMailboxData,
    isError: isMoveToMailboxError,
  } = useMutation({
    mutationFn: moveToMailbox,
    onSuccess: async (data) => {
      if (data?.status === 201 || data?.status === 200) {
        if (showSuccessToast) {
          toast.success(data?.data?.message ?? "Success");
        }
      } else {
        if (showErrorToast) {
          if (data?.data?.non_field_errors) {
            toast.error(data?.data?.non_field_errors[0]);
          } else {
            toast.error(data?.data?.message ?? "Something went wrong");
          }
        }
      }
    },
    onError: (error) => {
      if (showErrorToast) {
        toast.error("Error");
      }
    },
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });

  return {
    isMoveToMailboxLoading,
    mutateAsync,
    isMoveToMailboxSuccess,
    moveToMailboxData,
    isMoveToMailboxError,
  };
};

export default useMoveToMailboxHook;